import { IPaymentCardCommonData } from '../models/common/payments';
import { IB2BPaymentCard, TPhaLocType } from '../models/b2b/payments';

export const isT2CPrimaryPresent = (
  linesOfCredit: IPaymentCardCommonData[] | undefined,
  creditCards: IPaymentCardCommonData[] | undefined,
) => {
  const hasPrimaryT2cCreditCard =
    creditCards?.some((creditCard) => creditCard.t2cPrimary) ?? false;

  const hasPrimaryT2cLineOfCredit =
    linesOfCredit?.some((lineOfCredit) => lineOfCredit.t2cPrimary) ?? false;

  return hasPrimaryT2cCreditCard || hasPrimaryT2cLineOfCredit;
};

export const determineT2CPrimaryForPHA = (
  locType: IB2BPaymentCard['locType'],
  t2CPrimaryPresent: boolean,
) => {
  return !t2CPrimaryPresent && locType?.toUpperCase() !== TPhaLocType.PROJECT;
};
